import { useCallback } from 'react';
import { useRxCollection, useRxData } from 'rxdb-hooks';
import { v4 as uuidv4 } from 'uuid';

import { useMst } from '../../mobx-models/Root';
import { sentryCaptureException } from '../../utilities';
import { Checklist, Discipline } from '../../utilities/enums';
import { RxdbCollectionName } from '../rxdbCollectionName';
import { ComponentChecklist, ComponentChecklistCollection } from './queryBuilder';

const useComponentChecklist = () => {
  const { CurrentUserSelected, SiteDiscipline } = useMst();
  const componentChecklistCollection: ComponentChecklistCollection = useRxCollection(
    RxdbCollectionName.COMPONENT_CHECKLIST,
  );

  const getChecklistQuery = useCallback((collection: ComponentChecklistCollection) => {
    return collection?.find({
      selector: {
        inspectionTaskId: CurrentUserSelected.taskId,
      },
    });
  }, []);

  const { result: checklistData } = useRxData<ComponentChecklist>(
    RxdbCollectionName.COMPONENT_CHECKLIST,
    getChecklistQuery,
    { json: true },
  );

  const saveComponentChecklist = async (componentChecklistPayload: ComponentChecklist) => {
    const siteId = SiteDiscipline.siteId;
    const disciplineId = SiteDiscipline.disciplineId;
    try {
      const newUUID = uuidv4();
      let result = null;
      if (componentChecklistPayload[Checklist.PK_UUID]) {
        result = await componentChecklistCollection
          ?.findOne({
            selector: {
              pk_uuid: componentChecklistPayload[Checklist.PK_UUID],
            },
          })
          .update({
            $set: {
              isDelete: componentChecklistPayload[Checklist.IS_DELETE],
            },
          });
      }
      if (result === null) {
        const componentChecklistRecord: ComponentChecklist = {
          pk_AssetInspectionComponentChecklist: '0',
          pk_uuid: newUUID,
          isDelete: componentChecklistPayload[Checklist.IS_DELETE],
          assetCategoryComponent:
            disciplineId === Discipline.Shaft
              ? 0
              : Number(componentChecklistPayload[Checklist.ASSET_CATEGORY_COMPONENT]),
          checkListComponentName: componentChecklistPayload[Checklist.CHECKLIST_COMPONENT_NAME],
          inspectionId: CurrentUserSelected.inspectionId,
          inspectionTaskId: CurrentUserSelected.taskId,
          fkInspectorLead: componentChecklistPayload.fkInspectorLead,
          fkInspectorField: componentChecklistPayload.fkInspectorField,
          fk_Component:
            disciplineId === Discipline.Shaft
              ? Number(componentChecklistPayload[Checklist.FK_COMPONENT])
              : 0,
          site: siteId,
          discipline: disciplineId,
        };
        result = await componentChecklistCollection?.insert(componentChecklistRecord);
      }
      return result;
    } catch (error) {
      // console logs will be removed once sentry implementation is done
      sentryCaptureException(
        error,
        '~ file: useComponentChecklist.tsx ~ line 79 ~ saveComponentChecklist ~',
      );
    }
  };

  return { checklistData, saveComponentChecklist };
};

export default useComponentChecklist;
